import { RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import {MatCardModule} from '@angular/material/card';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTableModule} from '@angular/material/table';
import {MatInputModule} from '@angular/material/input';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatButtonModule} from '@angular/material/button';
import {MatExpansionModule} from '@angular/material/expansion';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import {MatListModule} from '@angular/material/list';
import {MatIconModule} from '@angular/material/icon';
import { SlideshowComponent } from './slideshow/slideshow.component';
import { AppRoutingModule } from './app-routing.module';
import {MatMenuModule} from '@angular/material/menu';
import { HardwareComponent } from './hardware/hardware.component';
import { IctpracticalComponent } from './ictpractical/ictpractical.component';
import { ChartsModule } from 'ng2-charts';
import { ModalComponent } from './modal/modal.component';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import { CsnotesComponent } from './csnotes/csnotes.component';
import { IctnotesComponent } from './ictnotes/ictnotes.component';



@NgModule({
  declarations: [
    AppComponent,
     HomeComponent,
     SlideshowComponent,
     HardwareComponent,
     IctpracticalComponent,
     ModalComponent,
     CsnotesComponent,
     IctnotesComponent
      ],
  imports: [
    BrowserModule,
    MatCardModule,
    MatGridListModule,
    MatToolbarModule,
    MatTableModule,
    MatInputModule,
    MatSidenavModule,
    MatButtonModule,
    MatExpansionModule,
    BrowserAnimationsModule,
    MatListModule,
    MatIconModule,
    AppRoutingModule,
    MatMenuModule,
    RouterModule,
    ChartsModule,
    MatBottomSheetModule
    
      
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {

 }
